import {useTranslation} from "react-i18next";
import {useLocation, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {
    getWellnessSurveyData,
    submitWellnessSurvey,
    updateWellnessSurvey,
    validateWellnessRegisterData
} from "../../../core/axios/services";
import Loader from "../../components/Loader/Loader";
import WellnessSurveyWelcomeScreen from "./sections/WellnessSurveyWelcomeScreen";
import WellnessSurveyRegisterScreen from "./sections/WellnessSurveyRegisterScreen";
import WellnessSurveyMetricsScreen from "./sections/WellnessSurveyMetricsScreen";
import WellnessSurveyOpenEndedScreen from "./sections/WellnessSurveyOpenEndedScreen";
import WellnessSurveyThankYouScreen from "./sections/WellnessSurveyThankYouScreen";
import {useSelector} from "react-redux";

export default function WellnessSurveyForm({showGlobalSnackbar, isEdit = false}){
    const { i18n } = useTranslation();
    const user = useSelector((state) => state.user);
    const {code} = useParams();
    const locationData = useLocation();
    let patientId = (new URLSearchParams(locationData.search)).get('patientId');
    let order = (new URLSearchParams(locationData.search)).get('order');
    let surveyId = (new URLSearchParams(locationData.search)).get('surveyId');



    const REGISTER_SCREEN = 'REGISTER_SCREEN';
    const WELCOME_SCREEN = 'WELCOME_SCREEN';
    const METRICS_SCREEN = 'METRICS_SCREEN';
    const OPEN_ENDED_SCREEN = 'OPEN_ENDED_SCREEN';
    const THANK_YOU_SCREEN = 'THANK_YOU_SCREEN';

    const [activeScreen, setActiveScreen] = useState()



    const [surveyData, setSurveyData] = useState();



    useEffect(() => {
        if(code && locationData && !surveyData){
            fetchWellnessSurveyData();
        }
    }, [code,locationData, surveyData]);

    async function fetchWellnessSurveyData() {
        patientId = (new URLSearchParams(locationData.search)).get('patientId');

        try {
            let result = await getWellnessSurveyData({
                settingsCode: code,
                patientId: patientId ?? null,
                order: order ?? null,
                surveyId: surveyId ?? null,
            });

            if(result?.data?.data){
                setSurveyData(result?.data?.data)
                setActiveScreen(WELCOME_SCREEN)
            }

        } catch (e) {
            console.log('error', e);
        }
    }


    const settingsData = surveyData?.settings;
    const clinicData = settingsData?.clinic;
    const themeColor = clinicData?.themeCustomColor;

    const [showAlreadyDone, setShowAlreadyDone] = useState(false)



    useEffect(() => {
        if(surveyData?.settings?.language?.code){
            i18n.changeLanguage(surveyData?.settings?.language?.code);
        }

        if(order && surveyData?.patientExist && surveyData?.latestOrder){
            if(order <= surveyData?.latestOrder && !isEdit){
                setShowAlreadyDone(true)
            }
        }
    }, [surveyData]);


    const [formData, setFormData] = useState();
    const [errorsData, setErrorsData] = useState();


    async function handleRegisterNext() {
        let isValidData = await handleValidateWellnessRegisterData();
        if (isValidData) {
            await setActiveScreen(METRICS_SCREEN)
        }
        scrollToTopInstant();
    }

    console.log('surveyData',surveyData);

    async function handleWelcomeNext() {
        if (surveyData?.patientExist) {
            await setActiveScreen(METRICS_SCREEN)
        } else {
            await setActiveScreen(REGISTER_SCREEN)
        }
        scrollToTopInstant();
    }

    async function handleMetricsNextScreen() {
        let openEndedQuestions = settingsData?.formattedOpenEndedQuestions ?? [];

        if (openEndedQuestions?.length > 0) {
            await setActiveScreen(OPEN_ENDED_SCREEN);
        } else {
            await handleSubmitWellnessSurvey();
        }
        scrollToTopInstant();
    }

    async function handleOpenEndedNext() {
        if (!isEdit) {
            await handleSubmitWellnessSurvey();
        } else {
            await handleUpdateWellnessSurvey();
        }
        scrollToTopInstant();
    }

    const [openEndedAnswers, setOpenEndedAnswers] = useState();

    useEffect(() => {
        if(settingsData?.formattedOpenEndedQuestions && !openEndedAnswers){
            setOpenEndedAnswers(settingsData?.formattedOpenEndedQuestions ?? [])
        }
    }, [settingsData]);

    async function handleSubmitWellnessSurvey() {
        try {
            let result = await submitWellnessSurvey({
                wellnessSetting:settingsData,
                patient: patientId ? {
                    id:patientId,
                    name: surveyData?.name,
                    lastName: surveyData?.lastName
                } : null,
                name:formData?.name,
                lastName:formData?.lastName,
                email:formData?.email,
                healthMetric1:formData?.healthMetric1,
                healthMetric2:formData?.healthMetric2,
                healthMetric3:formData?.healthMetric3,
                healthMetric4:formData?.healthMetric4,
                healthMetric5:formData?.healthMetric5,
                healthMetric6:formData?.healthMetric6,
                openEndedAnswers:openEndedAnswers
            });

            if(result?.status === 200){
                setActiveScreen(THANK_YOU_SCREEN);
            }else{
                if(result?.response?.data?.data?.emailTaken){
                    showGlobalSnackbar(result?.response?.data?.data?.message);
                    setActiveScreen(REGISTER_SCREEN)
                }
                console.log('result',result);
            }
        } catch (e) {
            console.log('error', e)
        }
    }


    async function handleMetricsPreviousScreen() {
        await setActiveScreen(WELCOME_SCREEN)
        scrollToTopInstant();
    }


    const handleValidateWellnessRegisterData = async () => {
        try {
            let result  = await validateWellnessRegisterData({...formData, clinicId:clinicData?.id});

            console.log('validateWellnessRegisterData',result);

            if(result?.status !== 200){
                setErrorsData({
                    email:result?.response?.data?.data?.email ?? result?.response?.data?.messages?.email?.[0],
                    lastName:result?.response?.data?.messages?.lastName?.[0],
                    name:result?.response?.data?.messages?.name?.[0],
                });

                return false;
            }

            return true;
        } catch (error) {
            showGlobalSnackbar(i18n.t("thereWasAnError"));
        }
    };


    async function handleOpenEndedPreviousScreen() {
        await setActiveScreen(METRICS_SCREEN);
        scrollToTopInstant();

    }


    function handleThankYouNext(){
        alert('DONE')
    }


    useEffect(() => {
        if(surveyData && isEdit){
            setFormData(surveyData?.orderSurvey);
            setOpenEndedAnswers(surveyData?.orderSurvey?.openEndedAnswers)
        }
    }, [isEdit, surveyData]);



    function scrollToTopInstant() {
        const el = document.documentElement; // <html>
        const prev = el.style.scrollBehavior;

        el.style.scrollBehavior = 'auto';

        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        // or: el.scrollTop = 0; document.body.scrollTop = 0;

        el.style.scrollBehavior = prev;
    }

    async function handleUpdateWellnessSurvey() {
        if(!isEdit){
            return;
        }
        console.log('user',user)
        try {
            let result = await updateWellnessSurvey({
                id:surveyData?.orderSurvey?.id,
                healthMetric1:formData?.healthMetric1,
                healthMetric2:formData?.healthMetric2,
                healthMetric3:formData?.healthMetric3,
                healthMetric4:formData?.healthMetric4,
                healthMetric5:formData?.healthMetric5,
                healthMetric6:formData?.healthMetric6,
                openEndedAnswers:openEndedAnswers
            },user);

            if(result?.status === 200){
                setActiveScreen(THANK_YOU_SCREEN);
            }else{
                setActiveScreen(WELCOME_SCREEN)
            }
        } catch (e) {
            console.log('error', e)
        }
    }


    console.log('clinicData',clinicData);

    return <div style={{scrollBehavior:'auto!important', background:'rgba(250, 250, 250, 1)', minHeight:'100vh'}}>
        {
            !activeScreen &&
            <div style={{width:'100%',minHeight:'50vh', display:'flex',justifyContent:'center',alignItems:'center'}}>
                <Loader/>
            </div>
        }

        {
            activeScreen && <div className={"wellnessMobileNarrow"} style={{
                padding:'clamp(12px, 2.5vw, 58px) clamp(10px, 4vw, 93px)',

            }}>
                <img
                    src={(clinicData?.logo && clinicData?.logo !== "") ? clinicData?.logo : '/assets/logotm.png'}
                    alt={clinicData?.name}
                    style={{
                        maxWidth:'175px',
                        maxHeight:'175px',
                        objectFit:'contain',
                        objectPosition:'left',
                    }}
                />
                <div
                    style={{
                        width:'100%',
                        minHeight:'calc(100vh - 235px)',
                        display:'flex',
                        justifyContent:'center',
                        alignItems:'center',
                        flexDirection:'column'
                    }}
                >

                    {
                        showAlreadyDone && <div>
                            <div className="ScreenOverlay" >
                                <div className="ScreenContent" style={{overflow:'hidden'}}>
                                    <h1 style={{textAlign:'center'}}>{i18n.t('alreadyCompletedSurvey')}</h1>
                                </div>
                            </div>
                        </div>
                    }

                    {
                        !showAlreadyDone && <>
                            { activeScreen === WELCOME_SCREEN &&
                                <WellnessSurveyWelcomeScreen
                                    patient={{
                                        name: surveyData?.name,
                                        lastName: surveyData?.lastName
                                    }}
                                    settingsData={settingsData}
                                    themeColor={themeColor}
                                    handleWelcomeNext={() => handleWelcomeNext()}
                                />
                            }

                            { activeScreen === REGISTER_SCREEN &&
                                <WellnessSurveyRegisterScreen
                                    formData={formData}
                                    setFormData={setFormData}
                                    handleRegisterNext={() => handleRegisterNext()}
                                    errorsData={errorsData}
                                    settingsData={settingsData}
                                    clinicData={clinicData}
                                    themeColor={themeColor}
                                />
                            }

                            { activeScreen === METRICS_SCREEN &&
                                <WellnessSurveyMetricsScreen
                                    formData={formData}
                                    setFormData={setFormData}
                                    errorsData={errorsData}
                                    settingsData={settingsData}
                                    clinicData={clinicData}
                                    themeColor={themeColor}
                                    previousSurvey={surveyData?.previousSurvey}
                                    handleMetricsNextScreen={() => handleMetricsNextScreen()}
                                    handleMetricsPreviousScreen={() => handleMetricsPreviousScreen()}
                                    buttonText={
                                        (settingsData?.formattedOpenEndedQuestions ?? [])?.length > 0
                                            ?
                                            i18n.t("next")
                                            :
                                            i18n.t("submit")
                                    }
                                />
                            }

                            { activeScreen === OPEN_ENDED_SCREEN &&
                                <WellnessSurveyOpenEndedScreen
                                    openEndedAnswers={openEndedAnswers}
                                    setOpenEndedAnswers={setOpenEndedAnswers}
                                    errorsData={errorsData}
                                    settingsData={settingsData}
                                    clinicData={clinicData}
                                    themeColor={themeColor}
                                    handleOpenEndedNext={() => handleOpenEndedNext()}
                                    handleOpenEndedPreviousScreen={() => handleOpenEndedPreviousScreen()}
                                />
                            }


                            { activeScreen === THANK_YOU_SCREEN &&
                                <WellnessSurveyThankYouScreen
                                    settingsData={settingsData}
                                    clinicData={clinicData}
                                    themeColor={themeColor}
                                    handleThankYouNext={() => handleThankYouNext()}
                                />
                            }
                        </>
                    }

                </div>
            </div>
        }

    </div>
}
